import http from '../../../services/http-common';

class AccessoryOpeningService {
    
    getAccessoryOpeningForList(data) {
        let queryParams = new URLSearchParams(data).toString();
        return http.get(`/AccessoryOpening/sp/list?${queryParams}`);
    }
    insert(data) {
        return http.post(`/AccessoryOpening/db/add`,data);
    }
    update(data) {
        return http.put(`/AccessoryOpening/db/update`,data);
    }
}

export default new AccessoryOpeningService();